<div class="w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Détails de consommation</div>
</div>

@if (files.length > 0 && files[0].documents.length > 0) {
    <div class="consumption-details">
        <div class="row header">
            <div class="col-6 align-content-start">Fichier</div>
            <div class="col-4">Date de la demande</div>
            <div class="col-2">Télécharger</div>
        </div>
        @for (document of files[0].documents; track document; let index = $index) {
            <div class="row" [ngClass]="{'gris-background': setBackgroundColor(index) == true}">
                <div class="col-6">{{ document.label }}</div>
                <div class="col-4">{{ document.date }}</div>
                <div class="col-2">
                    <a (click)="downloadFile( document.id, document.filename)" class="pointer-cursor">
                        <span class="tim-icons icon-cloud-download-93 pr-2 lca-color"></span>
                    </a>
                </div>
            </div>
        }
    </div>
}

<div class="col-12">
    <div class="bold-text">Date de début* :
        <mat-form-field>
            <input matInput (dateChange)="setSelectedDate($event.value, 'start')" [matDatepicker]="picker"/>
            <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon id="calendar-icon1">calendar_today</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>
</div>

@if (selectedStartDate) {
    <div class="col-12">
        <div class="bold-text">Date de fin* :
            <mat-form-field>
                <input matInput (dateChange)="setSelectedDate($event.value, 'finish')" [min]="selectedStartDate"
                       [max]="maxDate" [matDatepicker]="picker1"/>
                <mat-datepicker-toggle matSuffix [for]="picker1">
                    <mat-icon id="calendar-icon2">calendar_today</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
}

<div class="row w-100 pt-3 text-center">
    <div class="col-12 w-100 cta_container">
        <button type="button" class="cta_cancel column column" (click)="cancel()">Annuler<span></span></button>
        @if (selectedFinishDate) {
            <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
        }
    </div>
</div>